// Endast byggherren (eller projektägaren) får ändra Dok 50–55.
// Övriga roller ser dokumenten men i skrivskyddat läge.
import useProjectRole from "@/hooks/useProjectRole";

export interface ByggherreAccess {
  loading: boolean;
  canManage: boolean;
  canExport: boolean;
  role: string;
}

export const useByggherreAccess = (projectId?: string): ByggherreAccess => {
  const { loading, isOwner, role, canEdit, canExport } = useProjectRole(projectId);
  const canManage = canEdit && (isOwner || role === "Byggherre");
  return { loading, canManage, canExport: canExport || isOwner, role };
};

export default useByggherreAccess;
